import React, { useState, useEffect } from 'react';
import { Card, Table, Button, Tag, Space, message, Input, Select, Tabs, Popconfirm, Form, Row, Col, InputNumber, Modal, Divider, Upload } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined, SearchOutlined, ShoppingOutlined } from '@ant-design/icons';
import api from '../services/api';

const { Option } = Select;

const TIPOS_ITEM = ['produto', 'kit', 'insumo', 'brinde'];
const UNIDADES = ['Unidade', 'Caixa', 'Quilograma', 'Hora funcionário'];
const TIPOS_FISCAL = ['Ativo Imobilizado', 'Embalagem', 'Material de Uso e Consumo', 'Matéria-Prima', 'Mercadoria para revenda', 'Outras', 'Outros insumos', 'Produto Acabado', 'Produto em Processo', 'Produto Intermediário', 'Serviços', 'Subproduto'];
const ORIGENS = [
  '0 - Nacional, exceto as indicadas nos códigos 3 a 5',
  '1 - Estrangeira – Importação direta, exceto a indicada no código 6',
  '2 - Estrangeira – Adquirida no mercado interno, exceto a indicada no código 7',
  '3 - Nacional, mercadoria ou bem com conteúdo de importação superior a 40%',
  '4 - Nacional, cuja produção tenha sido feita em conformidade com os processos produtivos básicos',
  '5 - Nacional, mercadoria ou bem com Conteúdo de Importação inferior ou igual a 40%',
  '6 - Estrangeira - Importação direta, sem similar nacional, constante em lista de Resolução CAMEX',
  '7 - Estrangeira - Adquirida no mercado interno, sem similar nacional, constante em lista de Resolução CAMEX',
  '8 - Nacional, Conteúdo de Importação superior a 70%',
];
const CLASSIFICACOES = ['Comum', 'Medicamentos', 'Armamentos', 'Combustíveis', 'Veículos novos'];

const fmtMoeda = v => v ? 'R$ ' + parseFloat(v).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : '-';
const lucro = (custo, venda) => custo && venda ? (((venda - custo) / venda) * 100).toFixed(1) + '%' : '-';

function CodigosInternosTab({ codigosInternos, setCodigosInternos }) {
  const [modal, setModal] = useState(false);
  const [editando, setEditando] = useState(null);
  const [form] = Form.useForm();

  const salvar = async (values) => {
    try {
      if (editando) {
        const r = await api.put('/codigos-internos/' + editando.id, values);
        setCodigosInternos(prev => prev.map(ci => ci.id === editando.id ? r.data : ci));
      } else {
        const r = await api.post('/codigos-internos', values);
        setCodigosInternos(prev => [...prev, r.data]);
      }
      message.success('Salvo!');
      setModal(false);
      form.resetFields();
      setEditando(null);
    } catch(e) { message.error('Erro: ' + (e.response?.data?.erro || e.message)); }
  };

  const excluir = async (id) => {
    try {
      await api.delete('/codigos-internos/' + id);
      setCodigosInternos(prev => prev.filter(ci => ci.id !== id));
      message.success('Excluído!');
    } catch(e) { message.error('Erro: ' + (e.response?.data?.erro || e.message)); }
  };

  return (
    <>
    <Card size="small" style={{ marginBottom: 16 }}
      title="Códigos Internos"
      extra={<Button type="primary" icon={<PlusOutlined />} size="small" onClick={() => { setEditando(null); form.resetFields(); setModal(true); }}>Novo Código</Button>}>
      <Table dataSource={codigosInternos} rowKey="id" size="small" pagination={false}
        columns={[
          { title: 'Código', dataIndex: 'codigo', width: 120, render: v => <Tag color="blue">{v}</Tag> },
          { title: 'Ações', width: 80, render: (_, r) => (
            <Space size={4}>
              <Button size="small" icon={<EditOutlined />} onClick={() => { setEditando(r); form.setFieldsValue(r); setModal(true); }} />
              <Popconfirm title="Excluir?" onConfirm={() => excluir(r.id)}><Button size="small" danger icon={<DeleteOutlined />} /></Popconfirm>
            </Space>
          )},
          { title: 'Descrição', dataIndex: 'descricao' }
        ]}
      />
    </Card>
    <Modal title={editando ? 'Editar Código' : 'Novo Código Interno'} open={modal} onCancel={() => { setModal(false); setEditando(null); form.resetFields(); }} footer={null}>
      <Form form={form} layout="vertical" onFinish={salvar}>
        <Row gutter={16}>
          <Col span={8}><Form.Item name="codigo" label="Código" rules={[{ required: true }]}><Input placeholder="Ex: VALV" style={{ textTransform: 'uppercase' }} /></Form.Item></Col>
          <Col span={16}><Form.Item name="descricao" label="Descrição" rules={[{ required: true }]}><Input placeholder="Ex: Válvulas" /></Form.Item></Col>
        </Row>
        <Button type="primary" htmlType="submit" block>Salvar</Button>
      </Form>
    </Modal>
    </>
  );
}

export default function Produtos() {
  const [produtos, setProdutos] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [subcategorias, setSubcategorias] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [editando, setEditando] = useState(null);
  const [busca, setBusca] = useState('');
  const [novaCategoria, setNovaCategoria] = useState('');
  const [novaSubcategoria, setNovaSubcategoria] = useState('');
  const [categoriaSelecionada, setCategoriaSelecionada] = useState(null);
  const [salvando, setSalvando] = useState(false);
  const [codigosInternos, setCodigosInternos] = useState([]);
  const [imagemPreview, setImagemPreview] = useState(null);
  const [uploadingImagem, setUploadingImagem] = useState(false);
  const [fotos, setFotos] = useState([]);
  const [carregandoFotos, setCarregandoFotos] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    carregar();
    api.get('/codigos-internos').then(r => setCodigosInternos(r.data || [])).catch(() => {});
  }, []);

  const carregar = async () => {
    setLoading(true);
    try {
      const [r1, r2] = await Promise.all([
        api.get('/produtos'),
        api.get('/produtos/categorias/lista'),
      ]);
      setProdutos(r1.data);
      setCategorias(r2.data);
    } catch { message.error('Erro ao carregar produtos'); }
    finally { setLoading(false); }
  };

  const carregarSubcategorias = async (catId) => {
    if (!catId) { setSubcategorias([]); return; }
    const r = await api.get('/produtos/subcategorias/' + catId);
    setSubcategorias(r.data);
  };

  const abrirModal = (produto = null) => {
    setEditando(produto);
    if (produto) {
      form.setFieldsValue({ ...produto, _codigo_preview: produto.codigo });
      carregarSubcategorias(produto.categoria_id);
    } else {
      form.resetFields();
      setSubcategorias([]);
    }
    setModal(true);
  };

  const salvar = async (todosOsCampos) => {
    const { _codigo_preview, ...values } = todosOsCampos;
    setSalvando(true);
    try {
      if (editando) {
        await api.put('/produtos/' + editando.id, values);
        message.success('Produto atualizado!');
      } else {
        await api.post('/produtos', values);
        message.success('Produto cadastrado!');
      }
      setModal(false);
      carregar();
    } catch(e) { message.error(e.response?.data?.erro || 'Erro ao salvar produto'); }
    finally { setSalvando(false); }
  };

  const produtosFiltrados = produtos.filter(p =>
    (p.descricao || '').toLowerCase().includes(busca.toLowerCase()) ||
    (p.codigo || '').toLowerCase().includes(busca.toLowerCase()) ||
    (p.marca || '').toLowerCase().includes(busca.toLowerCase()) ||
    (p.tag || '').toLowerCase().includes(busca.toLowerCase())
  );

  const colunas = [
    { title: 'Código', dataIndex: 'codigo', width: 130, render: v => <Tag color="blue">{v}</Tag> },
    { title: 'Ações', width: 110, render: (_, r) => (
      <Space size={4}>
        <Button size="small" icon={<EditOutlined />} type="primary" onClick={() => abrirModal(r)} />
        <Button size="small" title="Código de Barras" onClick={async () => { const token = localStorage.getItem('token'); const res = await fetch('/api/produtos/' + r.id + '/barcode', { headers: { Authorization: 'Bearer ' + token } }); const blob = await res.blob(); const url = URL.createObjectURL(blob); window.open(url, '_blank'); }}>CB</Button>
        <Popconfirm title="Inativar produto?" onConfirm={async () => { await api.delete('/produtos/' + r.id); carregar(); }}>
          <Button size="small" danger icon={<DeleteOutlined />} />
        </Popconfirm>
      </Space>
    )},
    { title: 'Descrição', dataIndex: 'descricao', ellipsis: true, width: 250 },
    { title: 'TAG', dataIndex: 'tag', width: 120 },
    { title: 'Tipo', dataIndex: 'tipo_item', width: 90, render: v => <Tag>{v}</Tag> },
    { title: 'Custo', dataIndex: 'custo', width: 110, render: v => fmtMoeda(v) },
    { title: 'Venda', dataIndex: 'preco_venda', width: 110, render: v => fmtMoeda(v) },
    { title: 'Lucro', width: 80, render: (_, r) => <Tag color="green">{lucro(r.custo, r.preco_venda)}</Tag> },
  ];

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <h2 style={{ margin: 0 }}>Produtos</h2>
        <p style={{ color: '#888', margin: 0 }}>Cadastro de produtos e materiais</p>
      </div>

      <Tabs items={[
        {
          key: 'lista',
          label: <span><ShoppingOutlined /> Lista de Produtos</span>,
          children: (
            <Card size="small">
              <Row gutter={16} style={{ marginBottom: 12 }}>
                <Col span={12}><Input placeholder="Buscar por descrição, código, marca ou TAG..." prefix={<SearchOutlined />} value={busca} onChange={e => setBusca(e.target.value)} /></Col>
                <Col span={12} style={{ textAlign: 'right' }}>
                  <Button type="primary" icon={<PlusOutlined />} onClick={() => abrirModal()}>Novo Produto</Button>
                </Col>
              </Row>
              <Table columns={colunas} dataSource={produtosFiltrados} rowKey="id" size="small" loading={loading} pagination={{ pageSize: 20 }} />
            </Card>
          )
        },
        {
          key: 'categorias',
          label: 'Categorias',
          children: (
            <Row gutter={16}>
              <Col span={12}>
                <Card title="Categorias" size="small">
                  <Space style={{ marginBottom: 12 }}>
                    <Input placeholder="Nova categoria..." value={novaCategoria} onChange={e => setNovaCategoria(e.target.value)} />
                    <Button type="primary" icon={<PlusOutlined />} onClick={async () => {
                      if (!novaCategoria.trim()) return;
                      await api.post('/produtos/categorias/nova', { nome: novaCategoria });
                      setNovaCategoria('');
                      const r = await api.get('/produtos/categorias/lista');
                      setCategorias(r.data);
                    }}>Adicionar</Button>
                  </Space>
                  <Table dataSource={categorias} rowKey="id" size="small" pagination={false}
                    columns={[
                      { title: 'Nome', dataIndex: 'nome' },
                      { title: '', width: 50, render: (_, r) => (
                        <Popconfirm title="Remover categoria?" onConfirm={async () => { await api.delete('/produtos/categorias/' + r.id); const res = await api.get('/produtos/categorias/lista'); setCategorias(res.data); }}>
                          <Button size="small" danger icon={<DeleteOutlined />} />
                        </Popconfirm>
                      )}
                    ]}
                  />
                </Card>
              </Col>
              <Col span={12}>
                <Card title="Subcategorias" size="small">
                  <Space style={{ marginBottom: 12 }}>
                    <Select placeholder="Selecione a categoria" style={{ width: 180 }} onChange={v => { setCategoriaSelecionada(v); carregarSubcategorias(v); }}>
                      {categorias.map(c => <Option key={c.id} value={c.id}>{c.nome}</Option>)}
                    </Select>
                    <Input placeholder="Nova subcategoria..." value={novaSubcategoria} onChange={e => setNovaSubcategoria(e.target.value)} />
                    <Button type="primary" icon={<PlusOutlined />} onClick={async () => {
                      if (!novaSubcategoria.trim() || !categoriaSelecionada) return;
                      await api.post('/produtos/subcategorias/nova', { categoria_id: categoriaSelecionada, nome: novaSubcategoria });
                      setNovaSubcategoria('');
                      carregarSubcategorias(categoriaSelecionada);
                    }}>Adicionar</Button>
                  </Space>
                  <Table dataSource={subcategorias} rowKey="id" size="small" pagination={false}
                    columns={[{ title: 'Nome', dataIndex: 'nome' }]}
                  />
                </Card>
              </Col>
            </Row>
          )
        }
        ,{
          key: 'codigos_internos',
          label: 'Códigos Internos',
          children: <CodigosInternosTab codigosInternos={codigosInternos} setCodigosInternos={setCodigosInternos} />
        }
      ]} />

      <Modal title={editando ? 'Editar Produto' : 'Novo Produto'} open={modal} onCancel={() => { setModal(false); setImagemPreview(null); }} footer={null} width={800}>
        <Form form={form} layout="vertical" onFinish={salvar}>
          <Divider orientation="left">Dados Gerais</Divider>
          <Row gutter={16}>
            <Col span={12}><Form.Item name="descricao" label="Descrição" rules={[{ required: true }]}><Input /></Form.Item></Col>
            <Col span={6}><Form.Item name="tipo_item" label="Tipo de Item" initialValue="produto"><Select>{TIPOS_ITEM.map(t => <Option key={t} value={t}>{t}</Option>)}</Select></Form.Item></Col>
            <Col span={6}><Form.Item name="unidade" label="Unidade" initialValue="Unidade"><Select>{UNIDADES.map(u => <Option key={u} value={u}>{u}</Option>)}</Select></Form.Item></Col>
          </Row>
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item name="categoria_id" label="Categoria">
                <Select allowClear onChange={v => { carregarSubcategorias(v); form.setFieldsValue({ subcategoria_id: null }); }}>
                  {categorias.map(c => <Option key={c.id} value={c.id}>{c.nome}</Option>)}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="subcategoria_id" label="Subcategoria">
                <Select allowClear>{subcategorias.map(s => <Option key={s.id} value={s.id}>{s.nome}</Option>)}</Select>
              </Form.Item>
            </Col>
            <Col span={8}><Form.Item name="tag" label="TAG"><Input placeholder="Ex: Manômetro" /></Form.Item></Col>
          </Row>
          <Row gutter={16}>
            <Col span={8}><Form.Item name="marca" label="Marca"><Input /></Form.Item></Col>
            <Col span={8}><Form.Item name="modelo" label="Modelo"><Input /></Form.Item></Col>
          </Row>
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item name="codigo_interno" label="Código Interno">
                <Select allowClear showSearch optionFilterProp="children" placeholder="Selecione o código interno"
                  onChange={async v => {
                    if (!v) { form.setFieldsValue({ _codigo_preview: null }); return; }
                    if (editando && editando.codigo && String(editando.codigo).startsWith(v + '-')) {
                      form.setFieldsValue({ _codigo_preview: editando.codigo });
                      return;
                    }
                    try {
                      const r = await api.get('/codigos-internos/' + v + '/proximo');
                      form.setFieldsValue({ _codigo_preview: r.data.proximo });
                    } catch { form.setFieldsValue({ _codigo_preview: null }); }
                  }}>
                  {codigosInternos.map(ci => <Option key={ci.codigo} value={ci.codigo}>{ci.codigo} — {ci.descricao}</Option>)}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}><Form.Item name="codigo_barras" label="Código de Barras do Fabricante"><Input placeholder="EAN/GTIN" /></Form.Item></Col>
            <Col span={8}>
              <Form.Item name="_codigo_preview" label="Código do Produto (gerado automaticamente)">
                <Input disabled placeholder="Selecione o código interno..." />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item label="Fotos do Produto">
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 8 }}>
                  {fotos.map(f => (
                    <div key={f.id} style={{ position: 'relative' }}>
                      <img src={f.imagem_url} alt="foto" style={{ width: 80, height: 80, objectFit: 'cover', borderRadius: 6, border: f.principal ? '2px solid #1a3c5e' : '1px solid #ddd' }} />
                      <div style={{ position: 'absolute', top: 2, right: 2, display: 'flex', gap: 2 }}>
                        {!f.principal && <Button size="small" style={{ fontSize: 10, padding: '0 4px', height: 18, background: '#1a3c5e', color: '#fff', border: 'none' }} onClick={async () => {
                          await api.put('/produtos/' + editando.id + '/fotos/' + f.id + '/principal');
                          const rf = await api.get('/produtos/' + editando.id + '/fotos');
                          setFotos(rf.data || []);
                        }}>✓</Button>}
                        <Button size="small" danger style={{ fontSize: 10, padding: '0 4px', height: 18 }} onClick={async () => {
                          await api.delete('/produtos/' + editando.id + '/fotos/' + f.id);
                          const rf = await api.get('/produtos/' + editando.id + '/fotos');
                          setFotos(rf.data || []);
                          if (f.principal) setImagemPreview(null);
                        }}>×</Button>
                      </div>
                      {f.principal && <div style={{ position: 'absolute', bottom: 2, left: 2, background: '#1a3c5e', color: '#fff', fontSize: 9, padding: '0 3px', borderRadius: 2 }}>Principal</div>}
                    </div>
                  ))}
                </div>
                <input type="file" accept="image/*" multiple onChange={async e => {
                  const files = Array.from(e.target.files);
                  if (!files.length) return;
                  setUploadingImagem(true);
                  for (const file of files) {
                    await new Promise(resolve => {
                      const reader = new FileReader();
                      reader.onload = async ev => {
                        try {
                          const isPrimeira = fotos.length === 0;
                          await api.post('/produtos/' + (editando?.id || 'novo') + '/fotos', { imagem_url: ev.target.result, principal: isPrimeira });
                          if (isPrimeira) {
                            setImagemPreview(ev.target.result);
                            form.setFieldsValue({ imagem_url: ev.target.result });
                          }
                        } catch(err) {}
                        resolve();
                      };
                      reader.readAsDataURL(file);
                    });
                  }
                  if (editando?.id) {
                    const rf = await api.get('/produtos/' + editando.id + '/fotos');
                    setFotos(rf.data || []);
                  }
                  setUploadingImagem(false);
                  e.target.value = '';
                }} style={{ display: 'block' }} />
                <div style={{ fontSize: 11, color: '#888', marginTop: 4 }}>Selecione múltiplas fotos de uma vez. A primeira será a principal (marcada com ✓).</div>
              </Form.Item>
            </Col>
          </Row>

          <Divider orientation="left">Preços</Divider>
          <Row gutter={16}>
            <Col span={8}><Form.Item name="custo" label="Custo (R$)"><InputNumber style={{ width: '100%' }} precision={2} decimalSeparator="," prefix="R$" /></Form.Item></Col>
            <Col span={8}><Form.Item name="preco_venda" label="Preço de Venda (R$)"><InputNumber style={{ width: '100%' }} precision={2} decimalSeparator="," prefix="R$" /></Form.Item></Col>
            <Col span={8} style={{ paddingTop: 30 }}>
              <Form.Item noStyle shouldUpdate={(prev, cur) => prev.custo !== cur.custo || prev.preco_venda !== cur.preco_venda}>
                {({ getFieldValue }) => {
                  const c = getFieldValue('custo');
                  const v = getFieldValue('preco_venda');
                  const l = c && v ? (((v - c) / v) * 100).toFixed(1) : null;
                  return l ? <Tag color={parseFloat(l) > 0 ? 'green' : 'red'}>Lucro: {l}%</Tag> : null;
                }}
              </Form.Item>
            </Col>
          </Row>

          <Divider orientation="left">Fiscal</Divider>
          <Row gutter={16}>
            <Col span={12}><Form.Item name="tipo_fiscal" label="Tipo Fiscal"><Select allowClear>{TIPOS_FISCAL.map(t => <Option key={t} value={t}>{t}</Option>)}</Select></Form.Item></Col>
            <Col span={6}><Form.Item name="ncm" label="NCM"><Input placeholder="0000.00.00" /></Form.Item></Col>
            <Col span={6}><Form.Item name="cest" label="CEST"><Input placeholder="00.000.00" /></Form.Item></Col>
          </Row>
          <Row gutter={16}>
            <Col span={16}><Form.Item name="origem" label="Origem" initialValue={0}><Select>{ORIGENS.map((o, i) => <Option key={i} value={i}>{o}</Option>)}</Select></Form.Item></Col>
            <Col span={8}><Form.Item name="classificacao" label="Classificação" initialValue="Comum"><Select>{CLASSIFICACOES.map(c => <Option key={c} value={c}>{c}</Option>)}</Select></Form.Item></Col>
          </Row>

          <Button type="primary" htmlType="submit" block loading={salvando}>Salvar Produto</Button>
        </Form>
      </Modal>
    </div>
  );
}
